import React from 'react';
import { Select } from 'antd';
import { KRYBOT_AGENT_TYPES, KRYBOT_AGENT_TYPE_LABELS } from '../../types/krybot';

const { Option } = Select;

/** Options for Ant Design `<Select>` — all backend `agent_type` values. */
export const AgentTypeSelectOptions: React.FC = () => (
  <>
    {KRYBOT_AGENT_TYPES.map((t) => (
      <Option key={t} value={t}>
        {KRYBOT_AGENT_TYPE_LABELS[t]}
      </Option>
    ))}
  </>
);
